import { render } from "./AdjustmentListPage.vue?vue&type=template&id=3654cd59&ts=true"
import script from "./AdjustmentListPage.vue?vue&type=script&lang=ts"
export * from "./AdjustmentListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__